(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('InterventionDeleteController',InterventionDeleteController);

    InterventionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Intervention'];

    function InterventionDeleteController($uibModalInstance, entity, Intervention) {
        var vm = this;

        vm.intervention = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Intervention.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
